// Slice 7 R13: a ledger row's icon tile by look — Transactions' "What" column and Money →
// Overview's Recent transactions (044 D107).
import {
  RiCalendarCheckLine,
  RiEqualizerLine,
  RiFileList3Line,
  RiGiftLine,
  RiRestartLine,
  RiTimeLine,
  RiUserStarLine,
  RiWallet3Line,
} from "@remixicon/react";
import { tokens } from "../../utils/figmaTokens";

export const WHAT_LOOK = {
  topup: { Icon: RiWallet3Line, tone: tokens.success },
  checkout: { Icon: RiTimeLine, tone: tokens.neutral },
  lesson: { Icon: RiCalendarCheckLine, tone: tokens.info },
  refund: { Icon: RiRestartLine, tone: tokens.warning },
  adjustment: { Icon: RiEqualizerLine, tone: tokens.neutral },
  referral: { Icon: RiGiftLine, tone: tokens.success },
  other: { Icon: RiFileList3Line, tone: tokens.neutral },
  tutorPay: { Icon: RiUserStarLine, tone: tokens.neutral },
};
